import SchoolPaymentsTable from "./SchoolPaymentsTable";
import "../../styles/book-mgt.css";

const SchoolPayments = () => {
	return (
		<>
			<div className="component-body">
				<div className="page-title book-mgt-header">
					<h2>School Payments</h2>
				</div>

				<div className="mt-3">
					<SchoolPaymentsTable />
				</div>
			</div>
		</>
	)
};

export default SchoolPayments;